import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import * as fileSaver from 'file-saver';
import { SolicitudPersonaDocumentoValidarModel } from 'src/app/models/commands/solicitudes/solicitud-persona/SolicitudPersonaDocumentoValidarModel';
import { EstadoDocumentoItem, SolicitudSeccion } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { FilterSolicitudPersonaValidarRenovacionDocumentoModel } from 'src/app/models/queries/solicitudes/solicitud-persona/FilterSolicitudPersonaValidarRenovacionDocumento';
import { SolicitudPersonaDocumentoPorValidarRenovacionModel } from 'src/app/models/queries/solicitudes/solicitud-persona/SolicitudPersonaDocumentoPorValidarRenovacionModel';
import { SolicitudDocumentoModel } from 'src/app/models/solicitud/documento/SolicitudDocumentoModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { VisorPdfDialogComponent } from '../../shared/visor-pdf-dialog/visor-pdf-dialog.component';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { StorageService } from 'src/app/services/storage/storage.service';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-solicitud-validar-renovacion-documentos-lista',
  templateUrl: './solicitud-validar-renovacion-documentos-lista.component.html',
  styleUrls: ['./solicitud-validar-renovacion-documentos-lista.component.css']
})
export class SolicitudValidarRenovacionDocumentosListaComponent implements OnInit {
  modelFilter: FilterSolicitudPersonaValidarRenovacionDocumentoModel;
  modelLista: SolicitudPersonaDocumentoPorValidarRenovacionModel[];
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  listaSedes: ISedeModel[] = new Array<SedeModel>();
  resultsLength = 0;
  currentPage = 0;

  @ViewChild('paginator') paginator!: MatPaginator;

  displayedColumns: string[] = [
    'compania',
    'trabajador',
    'nroDocumentoIdentidad',
    'fechaVencimiento',
    'sede',
    'contratista',
    'codigo',
    'Documento',
    'idDocumento',
    'aprobado',
    'observado'
  ];

  constructor(
    private solicitudDocumentoService: SolicitudPersonaDocumentosService,
    public dialog: MatDialog,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
    private sedeService: SedeService,
    private solicitudPersonaDocumentoService: SolicitudPersonaDocumentosService,
    private storage: StorageService
  ) {
    this.modelLista = new Array<SolicitudPersonaDocumentoPorValidarRenovacionModel>();
    this.modelFilter = new FilterSolicitudPersonaValidarRenovacionDocumentoModel();
    let usuario = this.storage.getCurrentUser();
    this.listaCompanias = usuario.companias;
    this.modelFilter.idCompania = usuario.companiaDefault.idCompania;
  }

  ngOnInit(): void {
    this.companiaChanged();
    
    this.search();
  }

  companiaChanged() {

    this.listaSedes = [];
    this.modelFilter.sedes = [];
    let filterSede: IFilterSedeModel = new FilterSedeModel();
    filterSede.companias.push(this.modelFilter.idCompania);

    this.sedeService
      .getList(filterSede)
      .subscribe((data: ISedeModel[]) => {
        this.listaSedes = data;
      });
  }


  addDays(currentDate: Date, days: number): Date {
    currentDate.setDate(currentDate.getDate() + days);
    return currentDate;
  }

  search(): void {
    this.modelFilter.page = 1;
    this.solicitudDocumentoService.getListDocumentosPorValidarRenovacion(this.modelFilter).subscribe((data: SearchResultModel<SolicitudPersonaDocumentoPorValidarRenovacionModel[]>) => {
      this.modelLista = data.items;
      this.resultsLength = data.total;
      this.currentPage = 0;
      this.paginator.firstPage();
    });
  }

  getPaginatorData(event: any) {
    this.modelFilter.page = event.pageIndex + 1;
    this.modelFilter.pageSize = event.pageSize;
    this.solicitudDocumentoService
      .getListDocumentosPorValidarRenovacion(this.modelFilter)
      .subscribe(
        (data: SearchResultModel<SolicitudPersonaDocumentoPorValidarRenovacionModel[]>) => {
          this.modelLista = data.items;
          this.resultsLength = data.total;
        }
      );
  }

  changeAprobado(element: SolicitudPersonaDocumentoPorValidarRenovacionModel) {
    if (element.aprobado)
      element.observado = false;
  }

  changeObservado(element: SolicitudPersonaDocumentoPorValidarRenovacionModel) {
    // element.aprobado = !element.observado;
    if (element.observado)
      element.aprobado = false;
  }

  enviar() {
    this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
    this.confirmDialogService.confirmed().subscribe((confirmed) => {
      if (confirmed) {
        let listaDocumentos = new SolicitudPersonaDocumentoValidarModel();

        this.modelLista.filter(p => p.aprobado || p.observado).forEach(p => {

          let documento = new SolicitudDocumentoModel();
          documento.idDocumento = p.idSolicitudPersonaDocumento;
          if (p.aprobado) {
            documento.idEstado = EstadoDocumentoItem.APROBADO;
          }
          else if (p.observado) {
            documento.idEstado = EstadoDocumentoItem.OBSERVADO;
          }

          listaDocumentos.documentos.push(documento);
        });

        this.solicitudDocumentoService.validar(listaDocumentos).subscribe(p => {
          this.search();
        });
      }
    });
  }

  keyPressNumberOnly(event: any) {
    const pattern = /^[0-9]*$/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  esInvalido(): boolean {
    return this.modelLista.filter(p => p.aprobado || p.observado).length == 0;
  }

  export() {
    this.modelFilter.page = 1;
    this.solicitudDocumentoService.getListDocumentosPorValidarRenovacionToExport(this.modelFilter).subscribe(
      (data) => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, `documento-por-validar-${Date.now()}.xlsx`);
      },
      (error) => {
      }
    );
  }

  downloadDocumentFromService(element: SolicitudPersonaDocumentoPorValidarRenovacionModel) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Personal;
      modelVisor.idRegistro = element.solicitudPersona.idSolicitudPersona;
      modelVisor.idSolicitudDocumento = element.idSolicitudPersonaDocumento;
      modelVisor.codigoSolicitud = element.solicitudPersona.solicitud.codigo;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudPersonaDocumentoService
        .downloadDocumento(
          element.solicitudPersona.solicitud.codigo,
          element.solicitudPersona.idSolicitudPersona,
          element.idSolicitudPersonaDocumento
        )
        .subscribe(
          (data) => {
            let blob: any = new Blob([data], {
              type: 'text/json; charset=utf-8',
            });
            const url = window.URL.createObjectURL(blob);
            fileSaver.saveAs(blob, element.nombreArchivo);
          },
          (error) => {
          }
        );
    }
  }
}
